import { useState } from 'react';
import GalleryGrid from '../components/gallery/GalleryGrid';
import GalleryFilter from '../components/gallery/GalleryFilter';
import GalleryModal from '../components/gallery/GalleryModal';
import { useLanguage } from '../context/LanguageContext';
import { galleryCategories, getImagesByCategory } from '../data/gallery';

export default function Gallery() {
  const { t } = useLanguage();
  const [activeCategory, setActiveCategory] = useState('all');
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const filteredImages = getImagesByCategory(activeCategory);

  const handleImageClick = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? filteredImages.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === filteredImages.length - 1 ? 0 : prev + 1
    );
  };

  return (
    <div className="min-h-screen bg-cream-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-primary-800 dark:bg-primary-900 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {t('gallery.title')}
          </h1>
          <p className="text-lg text-primary-200 max-w-2xl mx-auto">
            {t('gallery.subtitle')}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Filter */}
        <GalleryFilter
          categories={galleryCategories}
          activeCategory={activeCategory}
          onCategoryChange={setActiveCategory}
        />

        {/* Grid */}
        <GalleryGrid
          images={filteredImages}
          onImageClick={handleImageClick}
        />
      </div>

      {/* Modal */}
      {modalOpen && (
        <GalleryModal
          images={filteredImages}
          currentIndex={currentIndex}
          onClose={() => setModalOpen(false)}
          onPrev={handlePrev}
          onNext={handleNext}
        />
      )}
    </div>
  );
}
